import { Injectable } from '@angular/core';
import { FeatureFlag } from '@core/const';
import { FeatureFlagActions, OccFeatureFlagService } from '@core/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class FeatureFlagEffects {
  loadFeatureFlags$: Observable<FeatureFlagActions.FeatureFlagsLoadFail | FeatureFlagActions.FeatureFlagsLoadSuccess> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(FeatureFlagActions.FEATURE_FLAGS_LOAD),
        mergeMap(() => {
          return this.occFeatureFlagService.load().pipe(
            map((response: FeatureFlag[]) => new FeatureFlagActions.FeatureFlagsLoadSuccess(response)),
            catchError(() => of(new FeatureFlagActions.FeatureFlagsLoadFail())),
          );
        }),
      ),
    );

  constructor(
    private actions$: Actions,
    private occFeatureFlagService: OccFeatureFlagService,
  ) {}
}
